/**************************************************************************************************************************************************
*   MODULE NAME     :  Abstract
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  13-01-2021
*   DESCRIPTION     :  Component to load All Abstracts page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import React from "react";
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import { Container, Row, Col, Form, Tooltip, OverlayTrigger, Button, Popover } from "react-bootstrap";
import { FaFilter, FaSpinner, FaExclamationTriangle, FaTimes, FaHashtag } from "react-icons/fa";
import { MdAddToQueue } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import swal from "sweetalert";
import DataTable from '../../common/dataTable/DataTable';
import { loadAllAbstractsData, loadAllAlerts, loadAllAbstractsDataPagination } from "../../../actions/abstractActions";
import { DOCUMENT_SITE_ORIGIN, SITE_PROCESSING_DOCUMENT, STATUS } from "../../../constants/constants";
import * as Helper from "../Common/abstractHelper";
import * as MessagePool from '../../common/MessagesPool';
import "./Abstracts.css";
import { ddmmmyyyyFormat } from "../../common/DateFormat";
import {
  loadAllProduct,
  loadAllCountry,
  loadAllExplanation,
  loadAllStatus,
  addAbstract,
  addAbstractBulk
} from "../../../actions/abstractActions";

class Abstracts extends React.Component {
  statusHandle = {
    'UNPROCESSED': {
      whereCond: {
       type: 'UNPROCESSED'
      },
      pageHeading: 'Unprocessed Abstracts'
    },
    'CLOSED': {
      whereCond: {
        type: 'CLOSED'
      },
      pageHeading: 'Closed Abstracts'
    },
    'DELETED': {
      whereCond: {
        type: 'DELETED'
      },
      pageHeading: 'Deleted Abstracts'
    },
    'ALL': {
      whereCond: {
        type: 'ALL'
      },
      pageHeading: 'Abstracts'
    }
  }
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      disableSave: true,
      selected: [],
      authors: '',
      title: '',
      filterAbstractDataList: [],
      addAbstractModalFlag: false,
      action: null,
      rowData: null,
      pageHeading: 'Unprocessed Abstracts',
      statusFilter: 'UNPROCESSED',
      alertMasterData: null,
      page1: 1,
      sizePerPage1: 25,
      editAllowed: this.props.loggedUserDetail.role.includes("Business_Administrator") || this.props.loggedUserDetail.role.includes("Literature_Associate"),
      deleteAllowed: this.props.loggedUserDetail.role.includes("Business_Administrator") || this.props.loggedUserDetail.role.includes("IT_Administrator"),
      updateList: [],
      statusList: [],
      explanationList: [],
      isLoading: false,
      displayTable: true,
      paginationData: {
        searchText: "",
        startFrom: 0,
        perPageLimit: 25,
        sortField: "dateRecordReceived",
        sortOrder: "desc",
        count: 0,
        page: 1,
        searchCount: 0,
      },
    }
    this.abstractDateFields = {
      dateRecordReceived: null,
      dateTranslationRequested: null,
      dateArticleOrdered: null,
      dateTranslationReceived: null,
      dateArticleOrdered2: null,
      dateAbstractValid: null,
      dateArticleReceived: null,
      dateArticleValid: null,
      dateAbstractReviewed: null,
      dateFlwUpReceived: null,
      dateArticleReviewed: null,
      dateClosed: null,
      dateTranslationValid: null,
      lockByDate: null
    }
  }

  async componentDidMount() {
    try {
      await this.loadAllStatus();
      await this.loadAllExplanation();
      await this.loadAlertsData();
      this.handleListStatusFilter({ target: {value: 'UNPROCESSED'}})
    } catch (e) {
      this.setLoader(false);
    }
  }

  loadData = ({
    searchText,
    sortField,
    sortOrder,
    filters,
    page,
    sizePerPage,

  }) => {
    this.setLoader(true);
    const startFrom = (page - 1) * sizePerPage;
    let {whereCond, pageHeading} = this.statusHandle[this.state.statusFilter];
    let paginationData = {
      searchText: (searchText === undefined ? '' : searchText),
      startFrom,
      perPageLimit: sizePerPage,
      sortField,
      sortOrder,
      page,
    };
    
    if((searchText != this.state.paginationData.searchText)) {
      paginationData.page = 1;
      paginationData.startFrom = 0;
    }
    this.setState({ paginationData }, () => this.loadAllAbstractsDataPagination(whereCond, {pageHeading}));
  };

  loadAllAbstractsData = async (payload = {}, setOptionalState = {}) => {
    this.setLoader(true);
    try {
      let res = await this.props.loadAllAbstractsData({...payload});
      if (res && res.data && res.data.result) {
        let resultData = res.data.result;

        resultData = await Promise.all(resultData.map(async row => {
          let abstractAlertData = {
            dateAbstractReviewed: row.dateAbstractReviewed,
            dateRecordReceived: row.dateRecordReceived,
            dateTranslationRequested: row.dateTranslationRequested,
            dateTranslationReceived: row.dateTranslationReceived,
            dateArticleOrdered: row.dateArticleOrdered,
            dateArticleReceived: row.dateArticleReceived,
            migrateFlag: row.migrateFlag,
            enblAlrtsAndVldtinsFlag: row.enblAlrtsAndVldtinsFlag
          }
          // Set Alert
          row.alert = await this.generateAlert(abstractAlertData);
          row.statusId = row.statusId ? '' + row.statusId : '';
          row.explanationId = row.explanationId ? '' + row.explanationId : '';
          return row;
        }));
        this.setState(prev => ({
          filterAbstractDataList: resultData,
          filterAbstractDataListMaster: prev.statusFilter === 'UNPROCESSED' ? JSON.parse(JSON.stringify(resultData)) : [],
          updateList: [],
          disableSave: true,
          ...setOptionalState
        }), () => this.setLoader(false))
      } else if (res && res.data.error) {
        swal('Oops !!', MessagePool.SERVER_ERROR, 'error')
        this.setLoader(false);
      }
    } catch (e) {
      this.setLoader(false);
    }

  }

  /**
   * Function to fetch all Abstracts
   */
   loadAllAbstractsDataPagination = async (payload = {}, setOptionalState = {}) => {
    this.setLoader(true);
    try {
      let { paginationData } = this.state;
      let res = await this.props.loadAllAbstractsDataPagination({...payload, paginationData});
    this.setLoader(true);
      if (res && res.data && res.data.result) {
        let resultData = res.data.result;

        const { count, searchCount } = resultData;

        resultData = await Promise.all(resultData.list.map(async row => {
          let abstractAlertData = {
            dateAbstractReviewed: row.dateAbstractReviewed,
            dateRecordReceived: row.dateRecordReceived,
            dateTranslationRequested: row.dateTranslationRequested,
            dateTranslationReceived: row.dateTranslationReceived,
            dateArticleOrdered: row.dateArticleOrdered,
            dateArticleReceived: row.dateArticleReceived,
            migrateFlag: row.migrateFlag,
            enblAlrtsAndVldtinsFlag: row.enblAlrtsAndVldtinsFlag
          }
          // Set Alert
          row.alert = await this.generateAlert(abstractAlertData);
          row.statusId = row.statusId ? '' + row.statusId : '';
          row.explanationId = row.explanationId ? '' + row.explanationId : '';
          return row;
        }));
        this.setState(prev => ({
          filterAbstractDataList: resultData,
          filterAbstractDataListMaster: prev.statusFilter === 'UNPROCESSED' ? JSON.parse(JSON.stringify(resultData)) : [],
          updateList: [],
          disableSave: true,
          paginationData: {...paginationData, count, searchCount},
          ...setOptionalState
        }), () => this.setLoader(false))
      } else if (res && res.data.error) {
        swal('Oops !!', MessagePool.SERVER_ERROR, 'error')
        this.setLoader(false);
      }
    } catch (e) {
      this.setLoader(false);
    }

  }

  /**
   * Function to handle the onchange event of form and update the state
   * @param {*} e 
   */
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleCreateAbstractBtnClick = () => {
    window.open("/createNewAbstract");
  }

  openAbstractDetailWindow = (abstractId) => {
    window.open(`/abstractDetail/${abstractId}`, "", `width=${window.innerWidth},height=${window.innerHeight}`);
  }

  /**
   * Function to handle filter of data table
   */
  handleListStatusFilter = event => {
    this.setLoader(true);
    const value = event.target.value;
    const whereCond = {};
    const optData = {};

    if(value === 'UNPROCESSED') {
      this.setState({
        statusFilter: value,
        displayTable: true,
        page1: 1,
        sizePerPage1: 25,
      }, () => {
        let {whereCond, pageHeading} = this.statusHandle[this.state.statusFilter];
        this.loadAllAbstractsData(whereCond, {pageHeading});
      })
    } else {
      this.setState({
        statusFilter: value,
        displayTable: false,
        paginationData: {
          searchText: "",
          startFrom: 0,
          perPageLimit: 25,
          sortField: "dateRecordReceived",
          sortOrder: "desc",
          count: 0,
          page: 1,
          searchCount: 0,
        }
      }, () => {
        this.setState({
          displayTable: true
        })
      })
    }
    
  };

  loadAlertsData = async () => {
    this.setLoader(true);
    let response = await this.props.loadAllAlerts();
    let alertMasterData = {};
    response.data.result.forEach((e) => {
      alertMasterData[e.masterDataKey] = e.masterDataValue
    })
    await this.setState(prevState => ({
      alertMasterData: alertMasterData

    }))
    this.setLoader(false);
  }
  /**
  * compare Dates
  */
  compareDate = (_date, _days) => {
    var date_C = new Date(_date);
    date_C.setDate(date_C.getDate() + _days);
    return (date_C <= new Date());
  }
  async generateAlert(abstract) {
    let alertFlag = false;
    let alertTitle = "";
    if (this.state.alertMasterData === null) {
      await this.loadAlertsData();
    }

    const { alertMasterData } = this.state;
    if (
      abstract.migrateFlag === false
    ) {
      if (!abstract["dateAbstractReviewed"]) {
        alertFlag = this.compareDate(
          abstract["dateRecordReceived"],
          parseInt(alertMasterData["ALERT_DAYS_ABST_NOT_REVD"])
        );
        alertTitle = "Abstract Not Reviewed";
      } else if (
        abstract["dateTranslationRequested"] &&
        !abstract["dateTranslationReceived"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateTranslationRequested"],
          parseInt(alertMasterData["ALERT_DAYS_ART_NOT_RECVD"])
        );
        alertTitle = "Translation Not Returned";
      } else if (
        abstract["dateArticleOrdered"] &&
        !abstract["dateArticleReceived"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateArticleOrdered"],
          parseInt(alertMasterData["ALERT_DAYS_ART_NOT_REVD"])
        );
        alertTitle = "Article Not Received";
      } else if (
        abstract["dateArticleReceived"] &&
        !abstract["dateArticleReviewed"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateArticleReceived"],
          parseInt(alertMasterData["ALERT_DAYS_TRANS_NOT_RET"])
        );
        alertTitle = "Article Not Reviewed";
      } else if (
        abstract["dateTranslationReceived"] &&
        !abstract["dateArticleReviewed"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateTranslationReceived"],
          parseInt(alertMasterData["ALERT_DAYS_TRANS_NOT_RET"])
        );
        alertTitle = "Article Not Reviewed";
      } else {
        alertFlag = false;
      }
    }
    return alertFlag;
  }
  loadAllExplanation = async () => {
    this.setLoader(true);
    let response = await this.props.loadAllExplanation();
    let resultData = Helper.getFormattedMasterData(response.data.result);
    let explanationMapper = {};
    resultData.forEach(e => explanationMapper[e.value] = e.label);
    resultData.sort((a,b) => a.label.localeCompare(b.label))
    await this.setState({
      explanationList: resultData,
      explanationMapper: explanationMapper
    });
    this.setLoader(false);
  }

  loadAllStatus = async () => {
    this.setLoader(true);
    let response = await this.props.loadAllStatus();
    let resultData = Helper.getFormattedMasterData(response.data.result);
    let statusMapper = {};
    resultData.forEach(e => statusMapper[e.value] = e.label);
    let filteredData = resultData.filter(e => e.value !== STATUS.LINKED && e.value !== STATUS.VALID && e.value !== STATUS.OTHER).sort((a,b) => a.label.localeCompare(b.label))
    await this.setState({
      statusList: filteredData,
      statusMapper: statusMapper
    });
    this.setLoader(false);
  }
  afterSaveFunction = (oldValue, newValue, row, column, done) => {
    let obj = this.state.filterAbstractDataListMaster.find(ele => ele.abstractId === row.abstractId);
    let objnew = this.state.filterAbstractDataList.find(ele => ele.abstractId === row.abstractId);
    if (newValue === "") return;
    if (`${oldValue}`.trim() !== `${newValue}`.trim() && (obj[column.dataField] !== `${newValue}`.trim())) {
      let arr = this.state.updateList;
      if (!arr.includes(row.abstractId)) {
        this.setState({
          updateList: [...this.state.updateList, row.abstractId],
          disableSave: false
        });
      }
    } else if (JSON.stringify(obj) === JSON.stringify(objnew) && this.state.updateList.includes(row.abstractId)) {
      let arr = this.state.updateList.filter(ele => ele !== row.abstractId)
      this.setState({
        updateList: JSON.parse(JSON.stringify(arr)),
        disableSave: arr.length === 0 ? true : this.state.disableSave && true
      });
    }
  }

  beforeSaveCell = (oldValue, newValue, row, column, done) => {
    if (newValue === "") {
      done(false);
    } else {
      done()
    }
  }
  setLoader = isLoading => this.setState({ isLoading });
  handleSaveFunction = async () => {
    this.setLoader(true);
    let abstracts = this.state.filterAbstractDataList;
    let abstractsOrg = this.state.filterAbstractDataListMaster;
    let { explanationMapper } = this.state;
    let valid = true;
    let updatedRows = this.state.updateList.map(id => {
      let row = abstracts.find(e => e.abstractId === id);
      let rowOrg = abstractsOrg.find(e => e.abstractId === id);
      if(!row.explanationId) {
        if(![STATUS.NON_VALID, STATUS.NOT_ORDERED, STATUS.DUPLICATE].includes(+row.statusId)) {
          row.explanationId = null;
        }
        if ([STATUS.NON_VALID, STATUS.NOT_ORDERED, STATUS.DUPLICATE].includes(+row.statusId) && !row.explanationId) {
          valid = false;
          swal('Oops !!', MessagePool.SELECT_EXPLANATION_ERROR, 'error')
          return;
        }
      }
      if(explanationMapper[row.explanationId] !== 'True Duplicate' && +row.statusId === STATUS.DUPLICATE) {
        valid = false;
        swal('Oops !!', MessagePool.SELECT_TRUE_DUPLICATE, 'error');
        return;
      }
      if (+rowOrg.statusId === STATUS.NEW && +row.statusId === STATUS.DUPLICATE) {
        valid = false;
        swal('Oops !!', MessagePool.SELECT_LINKED_ERROR, 'error')
        return;
      }
      if (explanationMapper[row.explanationId] === 'True Duplicate' && +row.statusId !== STATUS.LINKED && +row.statusId !== STATUS.DUPLICATE) {
        valid = false;
        swal('Oops !!', MessagePool.TRUE_DUPLICATE_EXPLANATION_ERROR, 'error')
        return;
      }
      if (explanationMapper[row.explanationId] === 'True Duplicate' && +row.statusId === STATUS.DUPLICATE) {
        row.active = false;
      }
      if ([STATUS.NOT_ORDERED, STATUS.VALID_NON_ENTRY, STATUS.VALID, STATUS.NON_VALID, STATUS.ARTICLE_NOT_RETRIEVABLE].includes(+row.statusId)) {
        row.dateClosed = new Date();
      }
      if ([STATUS.REVIEW_NEEDED, STATUS.OTHER, STATUS.ORDER_VALID, STATUS.ARTICLE_ORDERED_VALID, STATUS.ORDER_NON_VALID, STATUS.ARTICLE_ORDERED_NON_VALID, STATUS.NEW, STATUS.TRANSLATION_REQUESTED, STATUS.QUALITY_REVIEW].includes(+row.statusId)) {
        row.dateClosed = null;
      }
      if ([STATUS.NOT_ORDERED, STATUS.VALID_NON_ENTRY, STATUS.VALID, STATUS.NON_VALID].includes(+row.statusId) && row.dateClosed) {
        row.caseManagerId1 = this.props.loggedUserDetail.userClientId
      }
      if ([STATUS.ORDER_VALID].includes(+row.statusId)) {
        row.dateAbstractValid = new Date();
      }
      if ([STATUS.VALID].includes(+row.statusId) && row.dateArticleReceived) {
        row.dateArticleValid = new Date();
      }
      return row;
    });
    if (valid) {
      let res = await this.props.addAbstractBulk(updatedRows);
      if (res && res.data && res.data.result) {
        swal("Success", MessagePool.RECORDS_UPDATE_SUCCESS, "success").then(() => {
          this.handleListStatusFilter({ target: { value: this.state.statusFilter } });
        });
      } else {
        this.setLoader(false);
        swal('Oops !!', MessagePool.SERVER_ERROR, 'error')
      }
    } else {
      this.setLoader(false);
    }
  }


  render() {
    const {
      filterAbstractDataList,
      pageHeading,
      statusFilter,
      statusList,
      explanationList,
      statusMapper,
      explanationMapper,
      disableSave,
      page1,
      sizePerPage1,
      editAllowed,
      isLoading,
      paginationData,
      displayTable,
      deleteAllowed
    } = this.state;
    const UNPROCESSED = 'UNPROCESSED'
    // Appends ellipsis (...) on text based on charLimit
    const ellipsisFormatter = (content, charLimit) => {
      if (content.length > charLimit) {
        return <span>{content.substr(0, charLimit)}...</span>
      } else {
        return content;
      }
    }

    const rowClasses = (row, rowIndex) => {
      let classes = null;
      if (row && row.abstractId && this.state.updateList.includes(row.abstractId)) {
        classes = 'row-bg-color';
      }
      return classes;
    };
    const onSizePerPageChange = (page1, sizePerPage1) => {
      this.setState({
        page1,
        sizePerPage1,
      });
    };
    const pageProps = {
      page: page1,
      sizePerPage: sizePerPage1,
      onPageChange: (page1, sizePerPage1) =>
        onSizePerPageChange(page1, sizePerPage1),
      onSizePerPageChange: (sizePerPage1, page1) =>
        onSizePerPageChange(page1, sizePerPage1),
    };

    const abstractDataColumns = [
      {
        dataField: 'alert',
        text: 'Alert',
        csvExport: false,
        headerClasses: "width-5",
        editable: false,
        headerStyle: (colum, colIndex) => {
          return { width: '2vw' };
        },
        formatter: (cellContent, row) => {
          return <span style={{ display: 'inline-block', position: 'relative' }}>
            {row && (row.migrateFlag === true)
              && <FaHashtag style={{ color: 'gray' }} />}
            {row && row.active === false && <FaTimes style={{ color: 'red' }} />}
            {row && row.alert && row.active === true && row.enblAlrtsAndVldtinsFlag == true && <FaExclamationTriangle style={{ color: 'orange' }} />}
           </span>;

        }
      },
      {
        dataField: 'title',
        text: 'Title',
        sort: true,
        editable: false,
        headerClasses: 'width-100',
        style: { textAlign: "left" },
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="right"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "50vw" }} id="popover-contained">
                  <Popover.Content>{row.title}</Popover.Content>
                </Popover>
              }
            >
              <span
                className="fake-link"
                onClick={() => this.openAbstractDetailWindow(row.abstractId)}
              >
                {row.title && row.title.length <= (statusFilter === UNPROCESSED ? 70 : 100)
                  ? row.title
                  : row.title && row.title.substr(0, (statusFilter === UNPROCESSED ? 70 : 100)) + "..."}
              </span>
            </OverlayTrigger>
          );
          return row && row.title ? _popOver : "";
        },
      },
      {
        dataField: 'title',
        text: 'Title',
        hidden: true
      },
      {
        dataField: 'authors',
        text: 'Author(s)',
        sort: true,
        editable: false,
        style: { textAlign: "left" },
        headerStyle: (colum, colIndex) => {
          return { textTransform: 'none' };
        },
        headerClasses: 'width-100',
        attrs: (cell, row) => {
          return { title: row && row.authors ? row.authors : '' }
        },
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="right"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "40vw" }} id="popover-contained">
                  <Popover.Content>{row.authors}</Popover.Content>
                </Popover>
              }
            >
              <div>
                {row.authors&& row.authors.length <= (statusFilter === UNPROCESSED ? 70 : 100)
                  ? row.authors
                  : row.authors && row.authors.substr(0, (statusFilter === UNPROCESSED ? 70 : 100)) + "..."}
              </div>
            </OverlayTrigger>
          );
          return row && row.authors ? _popOver : "";
        },
        
      },
      {
        dataField: 'authors',
        text: 'Author',
        hidden: true
      },
      {
        dataField: 'product.masterDataValue',
        text: 'Product',
        sort: true,
        editable: false,
        align: 'left',
        headerClasses: 'width-50'
      },
      {
        dataField: 'statusId',
        text: 'Status',
        sort: true,
        align: 'left',
        editable: true,
        headerClasses: 'width-50',
        sortValue: (cellContent, row) => statusMapper ? statusMapper[row.statusId] : "",
        formatter: (cellContent, row) => {
          return row && row.statusId && statusMapper ? statusMapper[row.statusId] : ""
        },
        editor: {
          type: Type.SELECT,
          options: statusList
        }
      },
      {
        dataField: 'explanationId',
        text: 'explanation',
        sort: true,
        align: 'left',
        editable: true,
        headerClasses: 'width-50',
        sortValue: (cellContent, row) => explanationMapper ? explanationMapper[row.explanationId] : "",
        formatter: (cellContent, row) => {
          return row && row.explanationId && explanationMapper ? explanationMapper[row.explanationId] : ""
        },
        editor: {
          type: Type.SELECT,
          options: explanationList
        }
      },

      {
        dataField: 'dateRecordReceived',
        text: 'Date Record Received',
        sort: true,
        align: 'left',
        editable: false,
        headerClasses: 'width-60',
        formatter: (cellContent, row) => {
          return row && row.dateRecordReceived ? ddmmmyyyyFormat(row.dateRecordReceived) : ''
        }
      }
    ];

    return (
      <>
        {isLoading && (
          <div className="loader">
            <FaSpinner />
          </div>
        )}
        <div className="abstractWrap ">
          <Container fluid>
            <div className="headerpart">
              <h1>{pageHeading}</h1>
            </div>
            <div className="filter-action-section">
              <Row>
                <Col
                  sm={{ span: 2, offset: 7 }}
                  className="pr-0 text-right filterText pt-2"
                >
                  <FaFilter />
                  <strong>Status</strong>
                </Col>
                <Col sm={{ span: 2 }} className="addFilterBoxPos">
                  <Form.Control
                    as="select"
                    name="statusFilter"
                    value={statusFilter}
                    onChange={this.handleListStatusFilter}
                    defaultValue="All"
                  >
                    <option key="ALL" value="ALL">
                      All Abstracts
                    </option>
                    <option key="UA" value="UNPROCESSED">
                      Unprocessed Abstracts
                    </option>
                    <option key="CA" value="CLOSED">
                      Closed Abstracts
                    </option>
                   {deleteAllowed && ( <option key="DA" value="DELETED">
                      Deleted Abstracts
                </option>)}
                  </Form.Control>
                </Col>
                {statusFilter === UNPROCESSED && editAllowed && (
                  <Col sm={1} className="btns mb-0">
                    <Button
                      className="addBtn"
                      onClick={this.handleSaveFunction}
                      disabled={disableSave}
                      variant="btn btn-primary"
                    >
                      Save
                    </Button>
                  </Col>
                )}
              </Row>
            </div>
            {displayTable && (<div className="abstract-datatable pl-3 pr-3">
              {statusFilter === UNPROCESSED ? ( editAllowed ? (
                <DataTable
                  keyField="abstractId"
                  defaultSortField="dateRecordReceived"
                  data={filterAbstractDataList}
                  columns={abstractDataColumns}
                  csvName={false}
                  cellEdit={cellEditFactory({
                    mode: "click",
                    blurToSave: true,
                    beforeSaveCell: this.beforeSaveCell,
                    afterSaveCell: this.afterSaveFunction,
                  })}
                  rowClasses={rowClasses}
                  rowStyle={{ innerHeight: "20px" }}
                  pageProps={pageProps}
                />
              ) : (
                <DataTable
                  keyField="abstractId"
                  defaultSortField="dateRecordReceived"
                  data={filterAbstractDataList}
                  columns={abstractDataColumns}
                  csvName={false}
                  rowStyle={{ innerHeight: "20px" }}
                />
              )) : (
                <DataTable
                  keyField="abstractId"
                  defaultSortField="dateRecordReceived"
                  data={filterAbstractDataList}
                  columns={abstractDataColumns}
                  csvName={false}
                  loadData={this.loadData}
                  totalSize={paginationData.count}
                  searchCount={paginationData.searchCount}
                  page={paginationData.page}
                  remote
                />
              )}
            </div>)}
          </Container>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    loggedUserDetail: state.userDataReducer.loggedUserDetail,
  }
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      loadAllAbstractsData,
      loadAllAbstractsDataPagination,
      loadAllAlerts,
      loadAllProduct,
      loadAllCountry,
      loadAllExplanation,
      loadAllStatus,
      addAbstract,
      addAbstractBulk
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Abstracts));
